export default __webpack_public_path__ + "static/media/card-FiftyFifty.315d2e07.svg";